<template>
    <div class="armory-Attack-container">
        <div class="grid-cards">
            <AttackArmoryCardComponent v-for="ship in this.ships" 
                :key=ship.shipTypeId 
                v-bind="ship"
                v-model:planetQueue="ship.planetQueue" 
            />
        </div>
    </div>
</template>

<style scoped>
.armory-Attack-container{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.grid-cards {
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: repeat(auto-fit, minmax(352px, 1fr));
    gap: 24px;
    width: 100%;
}

@media screen and (max-width: 640px) {
    .grid-cards {
        grid-template-columns: repeat(auto-fit, minmax(311px, 1fr));
    }
}
</style>

<script>
import { sprintf } from 'sprintf-js';

import * as mercureTopicConstant from '@/constants/mercureTopicConstant';

import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

import AttackArmoryCardComponent from '@/components/AttackArmoryCardComponent.vue';

export default {
    name: 'AttackArmoryView',
    components: {
        AttackArmoryCardComponent,
    },
    setup() {
        const userLoginDataStorageInstance = userLoginDataStorage();
        return {
            userLoginDataStorageInstance,
            mercureTopicConstant
        }
    },
    data() {
        return {
            userId: this.userLoginDataStorageInstance.getUserId(),
            planetId: this.userLoginDataStorageInstance.getUserMainPlanetId(),
            ships: [],
            mercureConnection: null,
        }
    },
    mounted() {
        this.getBuildings();
        this.cretateMercureEvent();
    },
    unmounted() {
        this.closeMercureEvent();
    },
    methods: {
        getBuildings() {
            this.$axios.getPlanetShips(this.planetId).then(response => {
                console.log("Response data:", response.data);
                console.log("Response code:", response.status);
                console.log("Response headers:", response.headers);
                this.ships = response.data.shipDataCollection;
            }).catch(error => {
                console.error("Error ships request:", error);
            });
        },
        cretateMercureEvent()
        {
            this.mercureEvent = this.$mercure.createMercureEvent(
                sprintf(mercureTopicConstant.USER_SHIPS_VIEW_TOPIC, this.userId)
            );

            this.mercureEvent.onmessage = event => {
                const data = JSON.parse(event.data);
                const key = this.ships.findIndex(obj => obj.shipTypeId === data.shipTypeId);
                this.ships.splice(key, 1, data);
                this.$globalEvent.updateUserPlanetResourceView(this.planetId);
            };
        },
        closeMercureEvent()
        {
            this.mercureEvent.close();
            this.mercureEvent = null;
        }
    }
}
</script>